import {
  Button,
  PageHeader,
  Table,
  Modal,
  Form,
  Row,
  Col,
  Input,
  Select,
  Upload,
  Space,
  Descriptions,
  DatePicker
} from "antd";
import React, { useRef,useEffect, useState } from "react";
import { TeamOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { UploadOutlined, ReloadOutlined } from "@ant-design/icons";
import { v4 as uuid } from "uuid";
import { useApiContext } from "../../hooks/useApiContext"
import apis from "../../services/apis"
import moment from "moment";
import { dateFormat } from "../../utils/Constants";
import { PrintExpense } from "../../components/expense/PrintExpense";
import ReactToPrint from "react-to-print";
  

export default function DailyExpense() {
  const [expenseForm] = Form.useForm()
  let printRef = useRef();
  const { Column } = Table;
  const { expensedispatch, expenses, expensecategories, expensecategorydispatch, user} = useApiContext()
  const navigate = useNavigate();
  const [isopen, setIsopen] = useState(false);
  const [receipt, setReceipt] = useState();
  const [loading, setLoading] = useState(false)
  const [expenseEdit, setExpenseEdit] = useState(false)
  const [expenseId, setExpenseId] = useState("")
  const [showExpenseDetails, setShowExpenseDetails] = useState(false)
  const [expenseDetails, setExpenseDetails] = useState()
  const [expenseData, setExpenseData] = useState([])
  const [expenseTotal, setExpenseTotal] = useState(0)
  const [showTotal, setshowTotal] = useState(false)
  const [Date, setDate] = useState()
    const onFinish=(values)=>{
      setLoading(true)
      if(expenseEdit){
        const newValues = {...values, type:"fixedExpense", id:expenseId, date: Date}
        apis.Expenses.edit(expensedispatch, newValues).then(res=>{
          expenseForm.resetFields();
          setLoading(false)
          setIsopen(false)
          setExpenseEdit(false)
        })
        console.log("from edit", newValues);
      }
      else{

        const newValues = {...values, type:"fixedExpense", id:uuid()}
        console.log("expense value", newValues);
        apis.Expenses.create(expensedispatch, newValues).then(res=>{
          expenseForm.resetFields();
          setLoading(false)
          setIsopen(false)
        })
      }
    }
    useEffect(()=>{
      if(expenses.length <1) apis.Expenses.list(expensedispatch)
      setExpenseData(expenses.filter(x=>x.type =="fixedExpense"))
      if(expensecategories.length<1) apis.ExpenseCategory.list(expensecategorydispatch)
    },[expenses.length <1])
    const onFinishFailed=()=>{

    }

    const normFile = (e) => {
      setReceipt(e.file.originFileObj)
      console.log('Upload event:', e.file.originFileObj);
    
      if (Array.isArray(e)) {
        return e.file.originFileObj;
      }
    
      return e && e.fileList;
    };



    

    const editExpense=(values)=>{
      setExpenseEdit(true)
      setExpenseId(values.id)
      expenseForm.setFieldsValue({
        amount:values.amount,
        codeNumber:values.codeNumber,
        expenseCategoryId:values.expenseCategoryId,
        date:moment(values.date),
        description:values.description
      })
      setIsopen(true)
    }

    const getExpenseDetails=(values)=>{
      setShowExpenseDetails(true)
      setExpenseDetails(values)
    }
    const handleCategoryChange=(value)=>{
      setshowTotal(true)
      const byCategory = expenses.filter(x=>x.expenseCategoryId == value && x.type =="fixedExpense")
      setExpenseTotal(byCategory.reduce((a, b) => a + Number(b.amount), 0))
      setExpenseData(byCategory)
    }

    const getAllData =()=>{
      setExpenseData(expenses.filter(x=>x.type =="fixedExpense"))
      setshowTotal(false)
    }

  return (
    <>
    <PageHeader
    className="site-page-header"
    onBack={() => null}
    title="Expense List"
    subTitle="Find all the list of employees here"
    extra={[
      <Button type='primary' onClick={getAllData} icon={<ReloadOutlined />}>Refresh</Button>,
    <Button type='primary' onClick={()=>setIsopen(true)}  icon={<TeamOutlined />}>Add Fixed Expense</Button>]}
  />

  
{
        expenseData &&
      <>
      <Row style={{marginTop:'20px'}}>
        <Col span={10}>

       <Form.Item>
       <Form.Item label="Search by Category" name="expenseCategoryId">
               <Select placeholder="Select Category" onChange={ handleCategoryChange}>
                 {expensecategories && expensecategories.map(item =>(

                 <Select.Option value={item.id}>{item.categoryName}</Select.Option>
                 ))}
               </Select>
              </Form.Item>
      </Form.Item>
        </Col>
        <Col span={6} style={{marginLeft:'20px'}}>
          {showTotal && 
          
          <Form.Item label="Total Amount">
            <label>{expenseTotal}</label>
          </Form.Item>
          }
        </Col>
      </Row>
      <Table dataSource={expenseData} rowKey={record => record.id}>
      <Column title="Expense Code" dataIndex="codeNumber" key="id" />
   <Column title="Expense Amount" dataIndex="amount" key="id" />
   <Column title="Expense Date" dataIndex="date" key="id" />
   <Column   key="id" render={(text, record)=>(
     <Space size="middle">
       {
       user.role == "admin"
        &&
     <Button type="link" size="small" onClick={()=> editExpense(record)}>
         Edit
     </Button>
       }
       {
       user.role == "HR"
        &&
     <Button type="link" size="small" onClick={()=> editExpense(record)}>
         Edit
     </Button>
       }
     <Button type="link" onClick={()=> getExpenseDetails(record)}  size="small">
     
       View Details

     </Button>
   </Space>
   )} />
        </Table>
        </>
      }
  
   <Modal
          visible={isopen}
          title="Add Fixed Expense"
         footer={null}
         onCancel={()=>{
          setIsopen(false)
          setExpenseEdit(false)
         }}
         width={800}
        >
            <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          name="basic"
          form={expenseForm}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="gx-signin-form gx-form-row0"
        >
          <Row>
            <Col span={12}>
              <Form.Item
                label="Amount"
                name="amount"
                rules={[
                  { required: true, message: "Please enter expense amount" },
                ]}
              >
                <Input placeholder="0.00" />
              </Form.Item>

              <Form.Item label="Select Category" name="expenseCategoryId">
               <Select placeholder="Select Category" showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                }>
                 {expensecategories && expensecategories.map(item =>(

                 <Select.Option value={item.id}>{item.categoryName}</Select.Option>
                 ))}
               </Select>
              </Form.Item>
              <Form.Item
                name="file"
                label="Attach Receipt"
                valuePropName="fileList"
                getValueFromEvent={normFile}
              >
                <Upload name="file" listType="picture">
                  <Button icon={<UploadOutlined />}>
                    Click to upload Receipt
                  </Button>
                </Upload>
              </Form.Item>
              <Form.Item>
                <Button type="primary" loading={loading} className="gx-mb-0" htmlType="submit">
                  {expenseEdit ? "Update Expense": "Add Expense"}
                </Button>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Code Number"
                name="codeNumber"
                initialValue={`FEBG${Math.floor(Math.random() * 10000 + 1)}`}
                rules={[
                  { required: true, message: "Please enter expense amount" },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Date"
                name="date"
              >
                <DatePicker
              placeholder="DD/MM/YYYY"
              format={dateFormat}
                onChange={(date, dateString) => {
                  setDate(dateString);
                }}
              />
                {/* <Input type="date" /> */}
              </Form.Item>
              <Form.Item label="Description" name="description">
                <Input.TextArea rows={2} placeholder="Enter description" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
              
        </Modal>

        <Modal
          visible={showExpenseDetails}
          title="Daily Expense Details"
          footer={
            <ReactToPrint trigger={() => <Button type='primary'>Print</Button> } content={() => printRef.current} /> 
          }
         onCancel={()=>{
          setShowExpenseDetails(false)
          setExpenseDetails("")
         }}
         width={800}
        >
          {expenseDetails && <>
          <Descriptions bordered labelStyle={{fontWeight:'bold'}}>
            <Descriptions.Item label="Expense Code" span={2}>{expenseDetails.codeNumber}</Descriptions.Item>
            <Descriptions.Item label="Amount">{expenseDetails.amount}</Descriptions.Item>
            <Descriptions.Item label="Date" span={2}>{expenseDetails.date}</Descriptions.Item>
            <Descriptions.Item label="Category">{expenseDetails.expenseCategory?.categoryName}</Descriptions.Item>
            <Descriptions.Item label="Description"span={2}>{expenseDetails.description}</Descriptions.Item>

          </Descriptions>

          <div style={{display:'none'}}>
            {console.log("expenseDetails.date ",expenseDetails.date)}
            <PrintExpense
            expenseType="Daily Expense"
            expenseCode={expenseDetails.codeNumber}
            date={moment(expenseDetails.date).format('DD-MM-YYYY')}
            category={expenseDetails.expenseCategory?.categoryName}
            amount={expenseDetails.amount}
            description={expenseDetails.description}
            ref={printRef}
            />
          </div>




          </>}
          </Modal>
    </>
  )
}
